<template>
  <div>
    <h1 class="heading-1 mb-24">{{ i18n(translations.title) }}</h1>
    <p class="body-1 mb-24">{{ i18n(translations.description) }}</p>

    <StakeholderForm
      :description="i18n(translations.description)"
      :feature-code="FeatureCode.WEB_KYB_ACCOUNT_REQUESTER"
      :form-id="FORM_ID"
      :stakeholder-data="accountRequester"
      :title="i18n(translations.title)"
    />

    <!-- Save Button -->
    <div
      class="mx-auto mt-48 flex w-[328px] items-center justify-center gap-16"
    >
      <RevButton class="w-full" :form="FORM_ID" type="submit" variant="primary">
        {{ i18n(translations.saveButton) }}
      </RevButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { FeatureCode } from '@backmarket/nuxt-module-address/featureCode'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'

import type { KybData } from '~/scopes/kyb/pages/Index.types'

// import type { StakeholderFormValues } from '../components/StakeholderForm/StakeholderForm.types'
import StakeholderForm from '../components/StakeholderForm/StakeholderForm.vue'

import translations from './AccountRequester.translations'

const props = defineProps<{
  kybData: KybData
}>()

const i18n = useI18n()
const FORM_ID = 'kyb_account_requester_form'

const accountRequester = computed(() => props.kybData?.accountRequester)

// // TODO: Implement form submission logic
// async function handleSubmit(formValues: StakeholderFormValues) {
//   try {
//     // eslint-disable-next-line no-console
//     console.log('Account Requester form submitted:', formValues)
//   } catch (error) {
//     // console.error('Form submission error:', error)
//   }
// }
</script>
